const accordion = {
	init: function () {
		const accordions = document.querySelectorAll(".accordion__item");

		for (let i = 0; i < accordions.length; i++) {
			let button = accordions[i].querySelector(".accordion__title");

			button.addEventListener("click", () => {
				const content = <HTMLElement>(
					accordions[i].querySelector(".accordion__content")
				);
				button = accordions[i].querySelector(".accordion__title");

				if (content.classList.contains("open")) {
					content.classList.remove("open");
					button.classList.remove("open");
					content.style.maxHeight = null;
				} else {
					content.classList.add("open");
					button.classList.add("open");
					content.style.maxHeight = `${content.scrollHeight + 20}px`;
				}
			});
		}
	},
};

export default accordion;
